import * as React from 'react';
import {
  BaSeButton,
  BaSeIcon,
  BaSeTheme,
  BaSeSmall1,
  BaSeTag,
  BaSeHeading5,
  BaSeShapeButton,
  BaSeDialogContext,
} from '@base/react';
import {
  CardStyled,
  CardImage,
  SpanDataInfo,
  CardBody,
  CardBodyText,
  WrapperButton,
} from './card-styled';
import { ModalShared } from './modal-shared';
import { ImprimirCertificado } from '../../../pages/certificados-cliente/imprimir-certificado';

export const Card = ({
  id,
  cargaHoraria,
  dataFim,
  nomeCurso,
  url,
  image,
  mensagemParabens,
}) => {
  const { showModal } = React.useContext(BaSeDialogContext);
  // const { getActualUri } = Sebrae.useSebraeRouter();

  const { cinzaSebrae45 } = BaSeTheme.colors.institucionais;
  const { azulSebrae63 } = BaSeTheme.colors.brandbook;
  const { cinza67 } = BaSeTheme.colors.gestao;

  const shareData = React.useMemo(
    () => ({
      title: 'Compartilhar certificado',
      text: 'Acabei de obter um certificado do Sebrae',
      url: url,
    }),
    [url],
  );

  const handleModal = React.useCallback(() => {
    showModal({
      title: shareData.title,
      actions: [],
      size: 'small',
      content: ({ closeModal }) => (
        <ModalShared closeModal={closeModal} shareData={shareData} />
      ),
    });
  }, [shareData, showModal]);

  const handleShare = React.useCallback(() => {
    if (navigator.share) {
      navigator.share(shareData).then().catch().finally();
    } else {
      handleModal();
    }
  }, [handleModal, shareData]);

  return (
    <CardStyled key={id}>
      <CardImage image={image} />
      <SpanDataInfo>
        <BaSeSmall1 isBold color={cinzaSebrae45}>
          <BaSeIcon
            size={13.33}
            color={cinza67}
            name="clock-three"
            description={`Carga horária do curso ${nomeCurso}`}
          />
          Duração {cargaHoraria.replace(' horas', 'h').replace(' hora', 'h')}
        </BaSeSmall1>
        <BaSeSmall1 isBold color={cinzaSebrae45}>
          <BaSeIcon
            size={13.33}
            color={cinza67}
            name="calender"
            description={`Conclusão do curso ${nomeCurso}`}
          />
          Conclusão {dataFim}
        </BaSeSmall1>
      </SpanDataInfo>
      <CardBody>
        <div>
          <BaSeTag
            color="default"
            icon="trophy"
            label={mensagemParabens ?? 'Parabéns, aqui está seu certificado!'}
            type="primary"
            size="medium"
          />
          <CardBodyText>
            <BaSeHeading5 isBold color={cinzaSebrae45}>
              {nomeCurso}
            </BaSeHeading5>
          </CardBodyText>
        </div>
        <WrapperButton>
          <BaSeButton
            onClick={() => window.open(url)}
            value="Exibir certificado"
          />
          <ImprimirCertificado url={url} color={azulSebrae63} />
          <BaSeShapeButton
            buttonType="button"
            color={azulSebrae63}
            nameIcon="share-alt"
            onClick={handleShare}
            shape="square"
            size="medium"
            sizeIcon="medium"
            type="tertiary"
            popover={{
              direction: 'top',
              message: 'Compartilhar certificado',
            }}
          />
        </WrapperButton>
      </CardBody>
    </CardStyled>
  );
};
